import type { ReactNode } from 'react';

export interface ProfileContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * The profile pages' content column (MYN-217 approved mockups): up to 1440px
 * wide with 48px side gutters on desktop. The full-bleed header and the card
 * grid both sit inside it, so their edges line up.
 */
export function ProfileContainer({ children, className = '' }: ProfileContainerProps) {
  return (
    <div className={`mx-auto w-full max-w-[90rem] px-4 md:px-6 lg:px-12 ${className}`.trim()}>
      {children}
    </div>
  );
}
